import React, { FC } from 'react';
import styles from './Button.module.css';
import cls from 'classnames';

interface ButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({ children, onClick, disabled }) => (
  <button
    disabled={disabled}
    onClick={onClick}
    className={cls(
      styles.Button,
      'bg-dark hover:bg-dark-700 text-white font-bold py-2 px-4 rounded',
      'disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'
    )}
    data-testid="Button"
  >
    {children}
  </button>
);

export default Button;
